import React from 'react';
import { ShieldLogo } from './ShieldLogo';
import { Instagram, Facebook } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-dark text-brand-light pt-20 pb-10 border-t border-brand-light/10" data-id="element-106">
      <div className="container mx-auto px-6 md:px-12" data-id="element-107">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 mb-16 text-center md:text-left" data-id="element-108">
          {/* Brand */}
          <div className="flex flex-col items-center md:items-start" data-id="element-109">
            <ShieldLogo className="w-24 h-24 mb-6" data-id="element-110" />
            <h4 className="text-2xl font-heading tracking-wider mb-2" data-id="element-111">
              THE VALLEY
            </h4>
            <p className="text-sm font-semibold tracking-widest text-brand-orange mb-4" data-id="element-112">
              MOBILE GROOMING
            </p>
            <p className="text-brand-light/60 text-sm max-w-xs" data-id="element-113">
              Luxury pet grooming delivered to your door or experienced in our
              Goodyear salon.
            </p>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col items-center md:items-center" data-id="element-114">
            <h4 className="text-lg font-heading mb-6 text-brand-pink" data-id="element-115">
              Quick Links
            </h4>
            <ul className="space-y-3 text-brand-light/80" data-id="element-116">
              <li data-id="element-117">
                <a href="#home" className="hover:text-brand-orange transition-colors" data-id="element-118">
                  Home
                </a>
              </li>
              <li data-id="element-119">
                <a href="#services" className="hover:text-brand-orange transition-colors" data-id="element-120">
                  Services
                </a>
              </li>
              <li data-id="element-121">
                <a href="#about" className="hover:text-brand-orange transition-colors" data-id="element-122">
                  About Us
                </a>
              </li>
              <li data-id="element-123">
                <a href="#contact" className="hover:text-brand-orange transition-colors" data-id="element-124">
                  Contact
                </a>
              </li>
              <li data-id="element-125">
                <a href="#" className="hover:text-brand-orange transition-colors" data-id="element-126">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-127">
                <a href="#" className="hover:text-brand-orange transition-colors" data-id="element-128">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>

          {/* Social & Hours */}
          <div className="flex flex-col items-center md:items-end" data-id="element-129">
            <h4 className="text-lg font-heading mb-6 text-brand-pink" data-id="element-130">
              Connect
            </h4>
            <div className="flex gap-4 mb-8" data-id="element-131">
              <a href="#" className="text-brand-light/80 hover:text-brand-orange transition-colors" data-id="element-132">
                <Instagram size={24} data-id="element-133" />
              </a>
              <a href="#" className="text-brand-light/80 hover:text-brand-orange transition-colors" data-id="element-134">
                <Facebook size={24} data-id="element-135" />
              </a>
            </div>
            <div className="text-center md:text-right text-brand-light/60 text-sm space-y-1" data-id="element-136">
              <p className="font-semibold text-brand-light/80 mb-2" data-id="element-137">Hours</p>
              <p data-id="element-138">Mon–Sat: 8am–6pm</p>
              <p data-id="element-139">Sun: Closed</p>
            </div>
          </div>
        </div>

        <div className="border-t border-brand-light/10 pt-8 text-center text-sm text-brand-light/40" data-id="element-140">
          <p data-id="element-141">
            © {new Date().getFullYear()} The Valley Mobile Grooming. All Rights
            Reserved.
          </p>
        </div>
      </div>
    </footer>;
}